import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProtectedFileService {

  constructor(private http: HttpClient, private httpService: HttpService) { }


  setAttachmentStatus(paramData) {
    var request = {
      URL: "setAttachmentStatus/set",
      DATA: paramData
    }
    return this.httpService.post(request);
  }

  getAttachmentStatus(paramData){
    var request = {
        URL: "getAttachmentStatus/get",
        DATA:paramData
    }
    return this.httpService.post(request);
}

}

